/* eslint-disable max-len */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IExpedient } from 'bg-server/src/components/api/v1/expedient/types';

import { enquestaService } from 'src/services/enquesta';
import { expedientService } from 'src/services/expedient';

import { setLastActionStatus, setLoadingStatus } from '../app';
import { ICoreState } from '../types';

export const addExpedientEnquesta = createAsyncThunk<IExpedient, { formVersion: number, formType: string, preguntes: { [key: string]: string } }, { state: ICoreState }>('expedient/addExpedientEnquesta', async (data, thunkAPI) => {
    const { getState, dispatch } = thunkAPI;
    try {
        const user = getState().user.user._id;
        const expedient = getState().expedient.selectedExpedient._id;
        if (!user) {
            return null;
        }
        const { formVersion, formType, preguntes } = data;

        dispatch(setLoadingStatus(true));
        await enquestaService.addExpedientEnquesta(expedient, formVersion, formType, preguntes);
        const updatedExpedient = await expedientService.getExpedientById(expedient);
        dispatch(setLastActionStatus('enquestaAdded'));
        dispatch(setLoadingStatus(false));
        return updatedExpedient;
    } catch (error) {
        dispatch(setLoadingStatus(error.message ? error.message : error));
        throw error;
    }
});
